import Vue from 'vue';
import { mapGetters } from 'vuex';

import C from '@/components/C';

Vue.mixin({

  components: {
    C,
  },

  computed: {
    ...mapGetters('contents', ['Contents']),
  },

  methods: {
    c(key, text = '{}') {
      if (!this.Contents.hasOwnProperty(key)) {
        return `Undefined key ${key}`;
      }
      const { value } = this.Contents[key];
      return text.replace('{}', value);
    },
  },
});
